window.Shopify.cartAddOns = function (items) {
    var cartForm = document.getElementById('cart_form');
    if (cartForm) {
        var products = {}, addOnProducts = [];
        var cartQuantity = {
            main: {},
            addOns: [],
        }

        function showHideAddOns() {
            // Hide additional products section, if none available
            var availableAdditionalProducts = document.querySelectorAll('.iwa-additional-products .iwa-additional-products-collection .iwa-additional-products-item').length;
            if (!availableAdditionalProducts) {
                document.querySelector('.iwa-additional-products ').style.display = "none";
            }
        }

        function prepareData() {
            var i, item;

            // Process items to extract main products and add-ons
            for (i = 0; i < items.length; i++) {
                item = items[i];
                if (!item.product_tags || !item.product_tags.match(/_addon$/i)) {
                    // Main product
                    cartQuantity.main[item.product_tags] = {
                        quantity: item.quantity
                    };

                    products[item.product_tags] = item.item_id;
                } else {
                    // Add-on
                    cartQuantity.addOns[item.item_id] = {
                        tag: item.product_tags.replace(/_addon$/i, ''),
                        quantity: item.quantity
                    };

                    addOnProducts.push({
                        id: item.item_id,
                        tag: item.product_tags.replace(/_addon$/i, '')
                    });
                }
            }
        }

        function updateItemQuantity(index, list) {
            var item = list[index]
            $.post('/cart/change.json', {quantity: item.quantity, id: item.id}, function () {
                ++index;
                if (index < list.length) {
                    // Next one
                    updateItemQuantity(index, list);
                } else {
                    // Reload page
                    window.location.reload()
                }
            });
        }

        function syncQuantities() {
            var processList = [], itemId;

            for (itemId in cartQuantity.addOns) {
                if (cartQuantity.addOns.hasOwnProperty(itemId)) {
                    var addOn = cartQuantity.addOns[itemId];
                    var mainProduct = cartQuantity.main[addOn.tag];
                    if (mainProduct && addOn.quantity > mainProduct.quantity) {
                        processList.push({
                            id: itemId,
                            quantity: mainProduct.quantity
                        });
                    }
                }
            }

            if (processList.length) {
                // Disable cart and cart buttons
                disableCart();

                // Update quantity
                updateItemQuantity(0, processList)

                // Remove items from DOM
                syncDom(processList);
            }

            return !!processList.length;
        }

        function removeCartItems() {
            // Loop additional products, removing those that have not a course in the cart
            var i, processList = [];
            for (i = 0; i < addOnProducts.length; i++) {
                if (!products[addOnProducts[i].tag]) {
                    processList.push({
                        id: addOnProducts[i].id,
                        quantity: 0
                    });
                }
            }

            if (processList.length) {

                // Disable cart and cart buttons
                disableCart();

                // Remove all items from cart via AJAX
                // At the end of process, it reloads the page
                updateItemQuantity(0, processList);

                // Remove items from DOM
                syncDom(processList);
            }
        }

        function disableCart() {
            var element, i

            // Disable cart and cart buttons
            cartForm.classList.add('iwa-cart-disabled');
            element = cartForm.querySelectorAll('input.quantity');
            for (i = 0; i < element.length; i++) {
                element[i].disabled = true
            }
            element = cartForm.querySelectorAll('.action_button');
            for (i = 0; i < element.length; i++) {
                element[i].disabled = true
            }

            // Update price to 'Updating ...'
            // @todo From locale settings
            var priceLabel = 'Updating ...';
            element = cartForm.querySelectorAll('p.subtotal_amount strong');
            for (i = 0; i < element.length; i++) {
                element.innerHTML = priceLabel;
            }
            element = document.querySelectorAll('#cart .mm-counter');
            for (i = 0; i < element.length; i++) {
                element.innerHTML = priceLabel;
            }
        }

        function syncDom(list) {
            var div, i, total = 0;
            // Remove/update items from DOM
            for (i = 0; i < list.length; i++) {

                // Calculate total
                total += list[i].quantity;

                div = document.getElementById('cart_form_item_' + list[i].id);
                if (div) {
                    if (!list[i].quantity) {
                        // Remove from cart form
                        div.remove();
                    } else {
                        var quantity = div.querySelector('input.quantity');
                        if (quantity) {
                            quantity.value = list[i].quantity;
                        }
                    }
                }

                div = document.getElementById('cart_cart_item_' + list[i].id);
                if (div) {
                    if (!list[i].quantity) {
                        // Remove from sliding cart (accessible via cart badge top-right)
                        div.remove();
                    }
                }
            }

            // Update the cart badge
            var badge = document.querySelector('#iwa_header .icon-cart.cart-button .cart_count');
            if (badge) {
                badge.innerText = total;
            }
        }

        // Show / hide add-ons
        showHideAddOns();

        // Prepare data
        prepareData();

        // Sync add-ons quantities.
        // If any of the add-ons items has more items than main product, it'll adjust automatically
        // At the end of process, it reloads the page
        if (!syncQuantities()) {

            // Check if some items need removal
            removeCartItems();
        }

    }
}
